import { useEffect } from "react";
//redux salarycalculation
import {
  getSurplusBeforeTax,
  getTemplatePayrollTax,
  getFixedEarnedIncome,
  getTaxableIncome,
  getLocalTaxes,
  getStateTax,
  getPayrollTax,
  getGeneralPension,
  getFuneralFees,
  getReductionOfGeneralPension,
  getEarnedIncomeTax,
  getNetProfitPerYear,
  getNetProfitPerMonth,
  getGeneralPayrollTax,
  getGrossAnnualSalary,
} from "../Redux/Actions/salarycalculation";

//#region calculations to get monthly salary in dashboard per selected year
export const GetMonthlySalaryPerYear = (
  dispatch,
  calculating,
  templatePayrollPercent,
  standardTaxRelief,
  localTaxesPercent,
  payrollTaxPercent,
  generalPensionPercent,
  generalPensionCutOffValue,
  funeralFeesPercent,
  earnedIncomeTaxCutOffValue,
  earnedIncomeTaxPercent,
  generalPayrollTaxPercent,
  activeCompany,
  activeYear,
  totalFixedCost,
  totalYearGrossMargin,
  totalMeasuredCostsPerYear,
  nonTaxableIncomeLimit,
  stateTaxCutOfValue,
  stateTaxPercent,
  setCalculating
) => {
  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      function calculations() {
        //Measured per year
        let resultMeasured = 0;
        if (activeYear.year === "year1") {
          resultMeasured = totalMeasuredCostsPerYear.year1;
        }
        if (activeYear.year === "year2") {
          resultMeasured = totalMeasuredCostsPerYear.year2;
        }
        if (activeYear.year === "year3") {
          resultMeasured = totalMeasuredCostsPerYear.year3;
        }
        //get surplus before tax (överskott före skatter)
        const resultSurplus =
          totalYearGrossMargin - totalFixedCost - resultMeasured;
        if (resultSurplus === 0) {
          dispatch(getSurplusBeforeTax(0));
        } else {
          resultSurplus && dispatch(getSurplusBeforeTax(resultSurplus));
        }
        //get template payroll tax (egenavgifter schablon)
        let resultTemplatePayrollTax =
          (templatePayrollPercent / 100) * resultSurplus;
        if (resultSurplus <= 0) {
          resultTemplatePayrollTax = 0;
          dispatch(getTemplatePayrollTax(0));
        } else {
          resultTemplatePayrollTax &&
            dispatch(getTemplatePayrollTax(resultTemplatePayrollTax));
        }
        //#region CompanyForm in "Aktiebolag"
        //get General payroll tax (arbetsgivaravgift)
        let resultGeneralPayrollTax =
          (generalPayrollTaxPercent / 100) * resultSurplus;
        if (resultSurplus <= 0) {
          resultGeneralPayrollTax = 0;
          dispatch(getGeneralPayrollTax(0));
        } else {
          resultGeneralPayrollTax &&
            dispatch(getGeneralPayrollTax(resultGeneralPayrollTax));
        }

        //get gross year salary (Årslön brutto)
        let resultGrossAnnualSalary = resultSurplus - resultGeneralPayrollTax;
        if (resultSurplus <= 0) {
          resultGrossAnnualSalary = 0;
          dispatch(getGrossAnnualSalary(0));
        } else {
          resultGrossAnnualSalary &&
            dispatch(getGrossAnnualSalary(resultGrossAnnualSalary));
        }

        //get taxBase ("skatteunderlag" (Anders excel)
        let taxBase = resultGrossAnnualSalary + standardTaxRelief;
        if (resultGrossAnnualSalary <= nonTaxableIncomeLimit) {
          taxBase = 0;
        }
        //#endregion CompanyForm in "Aktiebolag"

        //get fixed earned income (fastställd förvärvsinkomst)
        let resultFixedEarnedIncome = resultSurplus - resultTemplatePayrollTax;
        if (resultSurplus <= 0) {
          resultFixedEarnedIncome = 0;
          dispatch(getFixedEarnedIncome(0));
        } else {
          resultFixedEarnedIncome &&
            dispatch(getFixedEarnedIncome(resultFixedEarnedIncome));
        }

        //get taxable income (beskattningsbar inkomst)
        let resultTaxableIncome = resultFixedEarnedIncome + standardTaxRelief;
        if (activeCompany.companyForm === "aktiebolag") {
          resultTaxableIncome = taxBase;
        }
        //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn. Cut off point salarycalculation stops. else standardtaxRelief is drawn
        if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultTaxableIncome = 0;
          dispatch(getTaxableIncome(0));
        } else {
          resultTaxableIncome &&
            dispatch(getTaxableIncome(resultTaxableIncome));
        }

        //get local taxes (kommunalskatt)
        let resultLocalTaxes = (localTaxesPercent / 100) * resultTaxableIncome;
        //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultLocalTaxes = 0;
          dispatch(getLocalTaxes(0));
        } else {
          resultLocalTaxes && dispatch(getLocalTaxes(resultLocalTaxes));
        }

        //get state tax (statlig skatt)
        let resultStateTax =
          (stateTaxPercent / 100) * (resultTaxableIncome - stateTaxCutOfValue);
        //if resultStateTax is less than the cut off value no state tax will be drawn.
        if (resultStateTax <= 0) {
          resultStateTax = 0;
          dispatch(getStateTax(0));
        } else {
          resultStateTax && dispatch(getStateTax(resultStateTax));
        }
        //egenavgifter
        let resultPayrollTax =
          (payrollTaxPercent / 100) * resultFixedEarnedIncome;
        if (resultPayrollTax === 0) {
          dispatch(getPayrollTax(0));
        } else {
          resultPayrollTax && dispatch(getPayrollTax(resultPayrollTax));
        }

        //get general pension (allmän pension)
        let resultGeneralPension =
          (generalPensionPercent / 100) * resultTaxableIncome;
        //if resultGeneralPension is more than the max cut off value max cut off value will be drawn.
        if (resultGeneralPension > generalPensionCutOffValue) {
          resultGeneralPension &&
            dispatch(getGeneralPension(generalPensionCutOffValue));
          resultGeneralPension = generalPensionCutOffValue;
          //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        } else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultGeneralPension = 0;
          dispatch(getGeneralPension(0));
        }
        //if resultGeneralPension is between cut off value and nonTaxable limit, pension will be drawn.
        else {
          resultGeneralPension &&
            dispatch(getGeneralPension(resultGeneralPension));
        }
        //get funeral fees (kyrko och begravningsavgift)
        let resultFuneralFees =
          (funeralFeesPercent / 100) * resultTaxableIncome;
        //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultFuneralFees = 0;
          dispatch(getFuneralFees(0));
        } else {
          resultFuneralFees && dispatch(getFuneralFees(resultFuneralFees));
        }
        //get reduction of general pension(skattereduktion för allmän pension)
        //resultReductionOfGeneralPension mirrors resultGeneralPension and same amount drawn will be returned
        let resultReductionOfGeneralPension = resultGeneralPension;
        if (resultReductionOfGeneralPension > generalPensionCutOffValue) {
          resultReductionOfGeneralPension &&
            dispatch(getReductionOfGeneralPension(generalPensionCutOffValue));
          //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn or returned.
        } else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultReductionOfGeneralPension = 0;
          dispatch(getReductionOfGeneralPension(0));
        } else {
          resultReductionOfGeneralPension &&
            dispatch(
              getReductionOfGeneralPension(resultReductionOfGeneralPension)
            );
        }
        //get earned income (jobbskatteavdrag)
        let resultEarnedIncomeTax =
          (earnedIncomeTaxPercent / 100) * resultTaxableIncome;
        //if resultEarnedIncomeTax is more than max cut off value, max cut off value will be returned
        if (resultEarnedIncomeTax > earnedIncomeTaxCutOffValue) {
          resultEarnedIncomeTax &&
            dispatch(getEarnedIncomeTax(earnedIncomeTaxCutOffValue));
          resultEarnedIncomeTax = earnedIncomeTaxCutOffValue;
          //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        } else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultEarnedIncomeTax = 0;
          dispatch(getEarnedIncomeTax(0));
        } else {
          //if resultEarnedIncome is less than max cut of value but more than non taxable limit earnedIncometax will be returned.
          resultEarnedIncomeTax &&
            dispatch(getEarnedIncomeTax(resultEarnedIncomeTax));
        }

        if (activeCompany.companyForm === "enskildFirma") {
          let resultNetProfitPerYear =
            resultSurplus -
            resultLocalTaxes -
            resultStateTax -
            resultPayrollTax -
            resultGeneralPension -
            resultFuneralFees +
            resultReductionOfGeneralPension +
            resultEarnedIncomeTax;
          if (resultNetProfitPerYear === 0) {
            dispatch(getNetProfitPerYear(0));
          }
          // if resultFixedEarnedIncome is less than the nontaxable limit no tax will be drawn but resultpayrolltax is always drawn
          else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
            resultNetProfitPerYear = resultFixedEarnedIncome - resultPayrollTax;
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYear(resultNetProfitPerYear));
          } else {
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYear(resultNetProfitPerYear));
          }

          //get net profit per month(månadslön netto)
          const resultNetProfitPerMonth = resultNetProfitPerYear / 12;
          if (resultNetProfitPerMonth === 0) {
            dispatch(getNetProfitPerMonth(0));
          } else {
            resultNetProfitPerMonth &&
              dispatch(getNetProfitPerMonth(resultNetProfitPerMonth));
          }
        } else if (activeCompany.companyForm === "aktiebolag") {
          let resultNetProfitPerYear =
            taxBase -
            resultLocalTaxes -
            resultGeneralPension -
            resultFuneralFees +
            resultReductionOfGeneralPension +
            resultEarnedIncomeTax -
            resultStateTax;
          if (resultNetProfitPerYear === 0) {
            dispatch(getNetProfitPerYear(0));
          } else if (taxBase <= nonTaxableIncomeLimit) {
            resultNetProfitPerYear = resultGrossAnnualSalary;
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYear(resultGrossAnnualSalary));
          } else {
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYear(resultNetProfitPerYear));
          }
          //get net profit per month(månadslön netto)
          const resultNetProfitPerMonth = resultNetProfitPerYear / 12;
          if (resultNetProfitPerMonth === 0) {
            dispatch(getNetProfitPerMonth(0));
          } else {
            resultNetProfitPerMonth &&
              dispatch(getNetProfitPerMonth(resultNetProfitPerMonth));
          }
        }
      }
      calculations();
      //give time for calculations() to calculate using calculating hook
      const delay = setTimeout(() => {
        setCalculating(true);
      }, 700);
      return () => clearTimeout(delay);
    }
    return () => {
      isMounted = false;
    };
  }, [
    dispatch,
    calculating,
    templatePayrollPercent,
    standardTaxRelief,
    localTaxesPercent,
    payrollTaxPercent,
    generalPensionPercent,
    generalPensionCutOffValue,
    funeralFeesPercent,
    earnedIncomeTaxCutOffValue,
    earnedIncomeTaxPercent,
    generalPayrollTaxPercent,
    activeCompany,
    activeYear.year,
    totalFixedCost,
    totalYearGrossMargin,
    totalMeasuredCostsPerYear,
    nonTaxableIncomeLimit,
    stateTaxCutOfValue,
    stateTaxPercent,
    setCalculating,
  ]);
  //#endregion calculations to get monthly salary in dashboard per selected year
};
